// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-card[data-v-33748160]{border-radius:5px;position:relative}.k-card[data-v-33748160]:before{display:none}.k-card__button--close[data-v-33748160]{color:#fff;opacity:.5;position:absolute;right:25px;top:27px}@media screen and (max-width:599px){.k-card__button--close[data-v-33748160]{right:15px;top:12px}}", ""]);
// Exports
module.exports = exports;
